__turbopack_context__.v({
  "bottomBlend": "NewsPageHeroImageLayers-module-scss-module__AGiDJG__bottomBlend",
  "darken": "NewsPageHeroImageLayers-module-scss-module__AGiDJG__darken",
  "grainNoise": "NewsPageHeroImageLayers-module-scss-module__AGiDJG__grainNoise",
});
